<div class="root-container">
  @for (i of items();track i){
    <div [class]="['item',i.style]">
      @switch (i.style){
        @case ('success'){
          <modal-icon preset="success" />
        }
        @case ('warning'){
          <modal-icon preset="warning" />
        }
        @case ('error'){
          <modal-icon type="danger" bi_icon="bi-x-circle" />
        }
        @case ('info'){
          <modal-icon type="info" bi_icon="bi-info-circle"/>
        }
        @case ('loading'){
          <spinner [size_px]="30" />
        }
      }
      <div class="item-body">
        <div class="item-style">{{ i.style }}</div>
        <div class="item-message">
          {{ i.message }}
          @if(i.type == 'timed'){
            ({{ ((i.time - i.elapsed )/ 1000) }})
          }
        </div>
      </div>
      <i class="bi bi-x close" (click)="toast.removeToast(i)"></i>
    </div>
  }
</div>
